import Cookies from 'js-cookie';

import api from '@/api';
import { AUTH_TOKEN, REFRESH_TOKEN } from '@/api/constants';

const authModel = {
    name: 'auth',
    state: {
        isLoggedIn: false,
        isLoggedOut: false,
        isSessionExpired: false,
        JWTError: false,
        JWTLoading: false,
        LDAPError: false,
        LDAPLoading: false,
        LDAPErrorMessage: '',
        username: null,
    },
    reducers: {
        setLoggedIn(state, payload) {
            return { ...state, isLoggedIn: payload };
        },
        setLoggedOut(state, payload) {
            return { ...state, isLoggedOut: payload };
        },
        setSessionExpired(state, payload) {
            return { ...state, isSessionExpired: payload };
        },
        setJWTError(state, payload) {
            return { ...state, JWTError: payload };
        },
        setJWTLoading(state, payload) {
            return { ...state, JWTLoading: payload };
        },
        setLDAPError(state, payload) {
            return { ...state, LDAPError: payload };
        },
        setLDAPErrorMessage(state, payload) {
            return { ...state, LDAPErrorMessage: payload };
        },
        setLDAPLoading(state, payload) {
            return { ...state, LDAPLoading: payload };
        },
        setUsername(state, payload) {
            return { ...state, username: payload };
        },
    },
    effects: () => ({
        async JWTAuth(data) {
            this.setJWTLoading(true);

            // TODO: refator redirect! Fast patch!
            const { redirect, ...credentials } = data;

            try {
                const login = await api.user.login(credentials);
                const session = await api.user.sessionClient(login.access);

                // В объекте пользователя имееются следующие поля, доступные на сервере.
                const { id, email, username, fullName, firstName, lastName, middleName } = session;

                Cookies.set(AUTH_TOKEN, login.access);
                Cookies.set(REFRESH_TOKEN, login.refresh);
                Cookies.set('version', process.env.APP_VERSION);
                Cookies.set('fullName', fullName);
                Cookies.set('username', username);
                Cookies.set('email', email);
                // Cookies.set('LDAPAuth', false);

                this.setJWTError(false);
                this.setLoggedIn(true);

                await redirect();
            } catch (error) {
                this.setLDAPError(false);
                this.setJWTError(true);
            } finally {
                this.setJWTLoading(false);
            }
        },
        async LDAPAuth(redirect) {
            this.setLDAPLoading(true);
            try {
                const ldap = await api.user.ldap();
                const session = await api.user.sessionClient(ldap.access);

                // В объекте пользователя имееются следующие поля, доступные на сервере.
                const { id, email, username, fullName, firstName, lastName, middleName } = session;

                if (!ldap.username && !session.username) {
                    this.setLDAPError(true);
                    this.setLDAPErrorMessage(ldap.error ?? '');
                    throw Error('LDAP auth error!');
                } else {
                    Cookies.set(AUTH_TOKEN, ldap.access);
                    Cookies.set(REFRESH_TOKEN, ldap.refresh);
                    Cookies.set('fullName', fullName);
                    Cookies.set('username', username);
                    // Cookies.set('LDAPAuth', true);

                    this.setUsername(username);
                    this.setLDAPError(false);
                    this.setLoggedIn(true);

                    await redirect();
                }
            } catch (error) {
                this.setJWTError(false);
                this.setLDAPError(true);
            } finally {
                this.setLDAPLoading(false);
            }
        },
    }),
};

export default authModel;
